export enum CustomRecurrenceEndTypeEnum {
  NEVER = 'NEVER',
  DATE = 'DATE',
  NUMBER_OF_APPOINTMENTS = 'NUMBER_OF_APPOINTMENTS'
}
